import React from 'react';
import { Link } from 'react-router-dom';

const socialLinks = [
  {
    key: 'instagram',
    href: '#',
    label: 'Instagram',
    icon: (
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" />
        <circle cx="12" cy="12" r="4.2" />
        <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    key: 'facebook',
    href: '#',
    label: 'Facebook',
    icon: (
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="currentColor">
        <path d="M13.4 21v-7.4h2.5l.4-3h-2.9V8.7c0-.9.2-1.5 1.5-1.5H16V4.5c-.2 0-1-.1-2-.1-2 0-3.4 1.2-3.4 3.6v2.6H8.4v3h2.2V21z" />
      </svg>
    ),
  },
  {
    key: 'youtube',
    href: '#',
    label: 'YouTube',
    icon: (
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="currentColor">
        <path d="M21.2 7.2a2.9 2.9 0 0 0-2-2C17.4 4.7 12 4.7 12 4.7s-5.4 0-7.2.5a2.9 2.9 0 0 0-2 2C2.3 9 2.3 12 2.3 12s0 3 .5 4.8a2.9 2.9 0 0 0 2 2c1.8.5 7.2.5 7.2.5s5.4 0 7.2-.5a2.9 2.9 0 0 0 2-2c.5-1.8.5-4.8.5-4.8s0-3-.5-4.8ZM10 15.5v-7l6 3.5z" />
      </svg>
    ),
  },
  {
    key: 'whatsapp',
    href: 'https://wa.me/919414555227',
    label: 'WhatsApp',
    icon: (
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="currentColor">
        <path d="M12 2.8a9 9 0 0 0-7.8 13.5L3 21l4.8-1.2A9 9 0 1 0 12 2.8Zm0 16.3a7.3 7.3 0 0 1-3.7-1l-.3-.2-2.8.7.8-2.7-.2-.3A7.3 7.3 0 1 1 12 19.1Zm4-5.5c-.2-.1-1.4-.7-1.6-.7s-.4-.1-.6.2-.7.7-.8.8-.3.2-.5.1a5.9 5.9 0 0 1-1.7-1 6.5 6.5 0 0 1-1.2-1.5c-.1-.2 0-.3.1-.5l.4-.5.2-.4a.5.5 0 0 0 0-.5c0-.1-.6-1.4-.8-1.9s-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 2.2 2.2 0 0 0-.7 1.6c0 1 .7 2 1 2.3.1.1 1.9 2.8 4.5 3.9 2.7 1 2.7.7 3.2.7.5-.1 1.4-.6 1.6-1.2.2-.6.2-1 .1-1.1s-.2-.1-.4-.2Z" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--ink)',
      borderTop: '3px solid var(--tiger)',
      padding: '80px 0 32px',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Tiger watermark */}
      <img src="/logo.png" alt="" style={{
        position: 'absolute', right: '-5%', bottom: '-10%',
        width: '35%', opacity: 0.04, pointerEvents: 'none',
        filter: 'invert(1)',
      }} />

      <div className="container" style={{ position: 'relative' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: '60px', marginBottom: '60px' }}>

          {/* Brand */}
          <div>
            <img src="/logo.png" alt="Karali Jaipur" style={{ height: 70, marginBottom: 16, filter: 'invert(1) sepia(1) saturate(2) hue-rotate(0deg) brightness(1.8)', opacity: 0.9 }} />
            <div style={{ width: 48, height: 1.5, background: 'var(--tiger-light)', marginBottom: 20, opacity: 0.6 }} />
            <p style={{ color: 'rgba(250,243,232,0.65)', fontSize: '0.98rem', lineHeight: 1.9 }}>
                   Where the wild spirit meets the art of royal hospitality            </p>
            <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
              {socialLinks.map((social) => (
                <a key={social.key} href={social.href} aria-label={social.label} target={social.href.startsWith('http') ? '_blank' : undefined} rel={social.href.startsWith('http') ? 'noreferrer' : undefined} style={{
                  width: 34, height: 34, border: '1px solid rgba(124,43,14,0.4)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'rgba(250,243,232,0.5)',
                  textDecoration: 'none', transition: 'all 0.3s',
                }}
                  onMouseEnter={e=>{e.currentTarget.style.borderColor='var(--tiger-light)';e.currentTarget.style.color='var(--tiger-light)';e.currentTarget.style.boxShadow='0 0 12px rgba(196,84,30,0.3)';}}
                  onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(124,43,14,0.4)';e.currentTarget.style.color='rgba(250,243,232,0.5)';e.currentTarget.style.boxShadow='none';}}
                >{social.icon}</a>
              ))}
            </div>
          </div>

          {/* Navigate */}
          <div>
            <h5 style={{ fontFamily:'var(--font-title)', fontSize:'0.58rem', letterSpacing:'0.45em', color:'var(--tiger-light)', textTransform:'uppercase', marginBottom:24 }}>Navigate</h5>
            {[['/', 'Home'], ['/menu','Our Menu'], ['/reservation','Reserve Table'], ['/about','About Us'], ['/gallery','Gallery'], ['/contact','Contact'], ['/admin', 'Admin Login'], ['/staff', 'Staff Login']].map(([p,l]) => (
              <Link key={p} to={p} style={{ display:'block', color:'rgba(250,243,232,0.55)', textDecoration:'none', fontFamily:'var(--font-body)', fontSize:'1.05rem', marginBottom:10, transition:'color 0.3s, padding-left 0.3s' }}
                onMouseEnter={e=>{e.currentTarget.style.color='var(--tiger-pale)';e.currentTarget.style.paddingLeft='8px';}}
                onMouseLeave={e=>{e.currentTarget.style.color='rgba(250,243,232,0.55)';e.currentTarget.style.paddingLeft='0';}}
              >{l}</Link>
            ))}
          </div>

           {/* Hours */}
          <div>
            <h5 style={{ fontFamily:'var(--font-title)', fontSize:'0.58rem', letterSpacing:'0.45em', color:'var(--tiger-light)', textTransform:'uppercase', marginBottom:24 }}>Hours</h5>
            {[
              { d:'Monday – Sunday', t:'8:00 AM – Late Night' },
            ].map(h => (
              <div key={h.d} style={{ marginBottom: 18 }}>
                <div style={{ color:'rgba(250,243,232,0.85)', fontFamily:'var(--font-title)', fontSize:'0.62rem', letterSpacing:'0.1em', marginBottom:4 }}>{h.d}</div>
                <div style={{ color:'rgba(250,243,232,0.5)', fontFamily:'var(--font-body)', fontSize:'0.98rem' }}>{h.t}</div>
              </div>
            ))}
          </div>


          {/* Contact */}
          <div>
            <h5 style={{ fontFamily:'var(--font-title)', fontSize:'0.58rem', letterSpacing:'0.45em', color:'var(--tiger-light)', textTransform:'uppercase', marginBottom:24 }}>Find Us</h5>
            <p style={{ color:'rgba(250,243,232,0.6)', fontSize:'1rem', lineHeight:1.9, marginBottom:16 }}>
              Terminal 2, Jaipur Airport Road<br />
              Jaipur, Rajasthan – 302006
            </p>
            <a href="tel:+919414555227" style={{ display:'flex', alignItems:'center', gap:8, color:'rgba(250,243,232,0.6)', textDecoration:'none', fontFamily:'var(--font-body)', fontSize:'1.05rem', marginBottom:10, transition:'color 0.3s' }}
              onMouseEnter={e=>e.currentTarget.style.color='var(--tiger-pale)'}
              onMouseLeave={e=>e.currentTarget.style.color='rgba(250,243,232,0.6)'}
            >📞 +91 94145 55227</a>
            <a href="mailto:table@karalijaipur.com" style={{ display:'block', color:'rgba(250,243,232,0.5)', textDecoration:'none', fontFamily:'var(--font-body)', fontSize:'0.98rem', transition:'color 0.3s' }}
              onMouseEnter={e=>e.currentTarget.style.color='var(--tiger-pale)'}
              onMouseLeave={e=>e.currentTarget.style.color='rgba(250,243,232,0.5)'}
            >table@karalijaipur.com</a>

            <div style={{ marginTop:24, padding:'14px 16px', border:'1px solid rgba(124,43,14,0.3)', background:'rgba(124,43,14,0.08)' }}>
              <div style={{ fontFamily:'var(--font-title)', fontSize:'0.52rem', letterSpacing:'0.3em', color:'var(--tiger-pale)', textTransform:'uppercase', marginBottom:6 }}>Founded By</div>
              <div style={{ fontFamily:'var(--font-display)', fontStyle:'italic', fontSize:'1.1rem', color:'rgba(250,243,232,0.8)' }}>Vishalakshi Business Enterprises</div>
              <div style={{ fontFamily:'var(--font-title)', fontSize:'0.52rem', letterSpacing:'0.2em', color:'rgba(250,243,232,0.4)', textTransform:'uppercase', marginTop:3 }}>Jaipur</div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div style={{ borderTop:'1px solid rgba(124,43,14,0.2)', paddingTop:28, display:'flex', flexWrap:'wrap', justifyContent:'space-between', alignItems:'center', gap:12 }}>
          <p style={{ color:'rgba(250,243,232,0.3)', fontSize:'0.85rem', fontFamily:'var(--font-body)' }}>
            © {new Date().getFullYear()} Karali Jaipur. All rights reserved. Founded by Vishalakshi Business Enterprises.
          </p>
          <div style={{ fontFamily:'var(--font-crown)', fontSize:'0.62rem', color:'rgba(196,84,30,0.3)', letterSpacing:'0.15em' }}>
            ◆ ESTD. 2026 ◆
          </div>
        </div>
      </div>
    </footer>
  );
}
